import { handleActions } from 'redux-actions';
import _invariant        from 'invariant';
import {
  fromJS,
  Map
}                        from 'immutable';
import {
  beginEditingContent,
  clearDraftContent,
  deregisterEditableContent,
  endEditingContent,
  registerEditableContent,
  updateDraftContent,
  updateInitialContent,
}                        from '../actions';

export const REGISTERED_CONTENT_STATE_KEY_COMPONENT_ID    = 'componentId';
export const REGISTERED_CONTENT_STATE_KEY_CONTENT_ID      = 'contentId';
export const REGISTERED_CONTENT_STATE_KEY_FRIENDLY_NAME   = 'friendlyName';
export const REGISTERED_CONTENT_STATE_KEY_INITIAL_CONTENT = 'initialContent';
export const REGISTERED_CONTENT_STATE_KEY_IS_EDITING      = 'isEditing';
export const REGISTERED_CONTENT_STATE_KEY_DRAFT_CONTENT   = 'draftContent';


const registeredContent = handleActions(
  {

    [registerEditableContent]: (state, {payload}) => {

      _invariant(
        !state.has(payload.componentId),
        'Attempting to register content with contentId of already registered component.'
      );

      return state.set(
        payload.componentId,
        fromJS(Object.assign({},
          payload,
          {
            [REGISTERED_CONTENT_STATE_KEY_COMPONENT_ID]:    payload.componentId,
            [REGISTERED_CONTENT_STATE_KEY_CONTENT_ID]:      payload.contentId,
            [REGISTERED_CONTENT_STATE_KEY_FRIENDLY_NAME]:   payload.friendlyName,
            [REGISTERED_CONTENT_STATE_KEY_INITIAL_CONTENT]: payload.initialContent,
            [REGISTERED_CONTENT_STATE_KEY_IS_EDITING]:      false,
            [REGISTERED_CONTENT_STATE_KEY_DRAFT_CONTENT]:   payload.initialContent,
          }))
      );

    },


    [deregisterEditableContent]: (state, {payload: {componentId}}) => {

      _invariant(
        state.has(componentId),
        'Attempting to deregister unregistered content'
      );

      return state.delete(componentId);

    },


    [beginEditingContent]: (state, {payload: {componentId}}) => {

      _invariant(
        state.has(componentId),
        'Attempting to begin editing unregistered content'
      );

      return state.setIn([componentId, REGISTERED_CONTENT_STATE_KEY_IS_EDITING], true);

    },


    [endEditingContent]: (state, {payload: {componentId}}) => {

      _invariant(
        state.has(componentId),
        'Attempting to end editing unregistered content'
      );

      return state.setIn([componentId, REGISTERED_CONTENT_STATE_KEY_IS_EDITING], false);

    },


    [updateInitialContent]: (state, {payload: {contentId, initialContent}}) => {

      const initialContentKey = REGISTERED_CONTENT_STATE_KEY_INITIAL_CONTENT;

      const items = findItemsByContentId({state, contentId})
        .filter(item => item.get(initialContentKey) !== initialContent);

      if (items.isEmpty()) {

        return state;

      }

      return state.merge(
        items.map(item => item.set(initialContentKey, initialContent))
      );

    },


    [updateDraftContent]: (state, {payload: {contentId, draftContent}}) => {

      const draftContentKey = REGISTERED_CONTENT_STATE_KEY_DRAFT_CONTENT;

      const items = findItemsByContentId({state, contentId})
        .filter(item => item.get(draftContentKey) !== draftContent);

      if (items.isEmpty()) {

        return state;

      }

      return state.merge(
        items.map(item => item.set(draftContentKey, draftContent))
      );

    },


    [clearDraftContent]: (state, {payload: {contentId}}) => {

      const draftContentKey = REGISTERED_CONTENT_STATE_KEY_DRAFT_CONTENT;
      const initialContentKey = REGISTERED_CONTENT_STATE_KEY_INITIAL_CONTENT;

      const items = findItemsByContentId({state, contentId})
        .filter(item => item.get(draftContentKey) !== item.get(initialContentKey));

      if (items.isEmpty()) {

        return state;

      }

      return state.merge(
        items.map(item => item.set(draftContentKey, item.get(initialContentKey)))
      );

    },

  },

  Map()
);


const findItemsByContentId = ({state, contentId}) => {

  return state.filter((content) => (content.get(REGISTERED_CONTENT_STATE_KEY_CONTENT_ID) === contentId));

};


export default registeredContent;


// WEBPACK FOOTER //
// ./src/modules/editableContent/reducers/registeredContent.js